import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.clear-fix {
    clear: both;
    width: 100%;
}
.summit-notice-wrapper {
    font-weight: bold;
    margin-top: calc(8px * 2);
    display: flex;
    align-items: center;
    border-radius: 5px;
    font-size: 14px;
    color: #3b4b59;
    background-repeat: no-repeat;
    background-position: 12px center;
    overflow: hidden;
}
.subpage-summit-notice-wrapper {
    font-weight: bold;
    margin-top: calc(8px * 2);
    display: flex;
    align-items: center;
    border-radius: 5px;
    font-size: 14px;
    color: #3b4b59;
    background-repeat: no-repeat;
    background-position: 12px center;
    overflow: hidden;
}
.summit-notice-wrapper.loading::before {
    content: ' ';
    width: calc(8px * 2);
    height: calc(8px * 2);
    display: block;
    position: relative;
    border-radius: 100%;
    margin-right: 8px;
}
.subpage-summit-notice-wrapper.loading::before {
    content: ' ';
    width: calc(8px * 2);
    height: calc(8px * 2);
    display: block;
    position: relative;
    border-radius: 100%;
    margin-right: 8px;
}
.summit-notice-wrapper.loading::after {
    content: ' ';
    display: block;
    height: calc(8px * 2);
    flex: 1;
}
.subpage-summit-notice-wrapper.loading::after {
    content: ' ';
    display: block;
    height: calc(8px * 2);
    flex: 1;
}
.summit-notice-wrapper {
    margin: 0 auto;
    padding: calc(8px * 2);
    background: #eeeeee;
}
.subpage-summit-notice-wrapper {
    padding-bottom: calc(8px * 2);
}
.summit-notice-wrapper.loading::before {
    background: #b4babf;
}
.summit-notice-wrapper.loading::after {
    background: #b4babf;
}
.summit-notice-wrapper.loading {
    display: flex;
    /* height: 16px; */
}
.summit-notice :global(a) {
    color: #086ea1;
}
.summit-notice-wrapper :global(.unlock.icon),
.summit-notice-wrapper :global(.lock.icon) {
    position: relative;
}
.summit.icon {
    margin-right: 10px;
}
`;

export default styles;